import { useI18n } from "@/lib/i18n";
import { useParametres } from "@/hooks/useParametres";
import { useSeo } from "@/hooks/useSeo";
import { truncate } from "@/lib/seo";

function Privacy() {
  const { t } = useI18n();
  const { data: parametres } = useParametres();
  const titre = parametres?.["pages.privacy.titre"];
  const corps = parametres?.["pages.privacy.corps"];

  useSeo({
    title: `${titre || t("privacy.heading")} — Ramba News`,
    description: truncate(corps || t("privacy.body")),
    path: "/privacy",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 py-14">
      <h1 className="font-serif text-3xl md:text-4xl font-semibold tracking-tight">{titre || t("privacy.heading")}</h1>
      <p className="mt-4 text-muted-foreground leading-relaxed whitespace-pre-wrap">{corps || t("privacy.body")}</p>
    </div>
  );
}

export default Privacy;
